import { JSX, ReactNode } from "react";
import { useSelector } from "react-redux";
import ProtectedPage from "rivals/components/app/ProtectedPage";
import { isAuthenticated } from "rivals/redux/authentication/selectors";

/**
 * Wrapper for ProtectedPage that uses Redux to check if the user is authenticated
 * Only use in Page Router
 */
export default function ProtectedPageWrapper({
  children
}: {
  children: ReactNode;
}): JSX.Element {
  return (
    <ProtectedPage isAuthenticated={useSelector(isAuthenticated)}>
      {children}
    </ProtectedPage>
  );
}
